// import { useFetchNew } from "../../data/fetch/useFetch";
// import { getConfiguration } from "../../data/utils";
// import { parsePageDataAvertising } from "../../data/parsePageDataAdvertising";
import { usePageData } from "../PageDataProvider";

export default function BannersFetcher(props) {
    // const conf = getConfiguration();
    // const url = props.isMobile ? conf.api.getPageDataAdvertisingMobile : conf.api.getPageDataAdvertising;
    // const [isLoading, isError, data] = useFetchNew(url, null, (data) =>
    //     parsePageDataAvertising(data)
    // );

    // if (isLoading || isError) {
    //     return null;
    // }

    const data = usePageData();

    return props.renderItem(data);
}
